// src/polyfills.js - Ensure all polyfills are properly loaded before any other imports

// Buffer polyfill
import { Buffer } from 'buffer';

// Make Buffer available globally
if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
  // Ensure global is available, vite-plugin-node-polyfills should also handle this
  if (typeof window.global === 'undefined') {
    window.global = window;
  }
} else if (typeof global !== 'undefined') {
  // For Node.js or other environments if needed, though primarily for browser
  global.Buffer = Buffer;
}


// process polyfill
// vite-plugin-node-polyfills provides 'process'. If you need to ensure it's on window:
import process from 'process';
if (typeof window !== 'undefined' && typeof window.process === 'undefined') {
  window.process = process;
}


// Other common Node.js core module polyfills (vite-plugin-node-polyfills handles these by default)
// You typically don't need to import them explicitly here if the plugin is active,
// but shown for completeness or if specific global assignment is needed.
// import util from 'util';
// import events from 'events';

// Example: Making EventEmitter global if a library expects it
// import { EventEmitter } from 'events';
// if (typeof window !== 'undefined' && typeof window.EventEmitter === 'undefined') {
//   window.EventEmitter = EventEmitter;
// }

console.log('Polyfills loaded: Buffer, global, process (via vite-plugin-node-polyfills or explicit).');